export default "__VITE_ASSET__CkCMxlqh__"